// MARK://dhk8/admin-shell/pages/modules/SuperadminPage
// Módulo 9 — Superadmin: "Cuentas de terceros" (rol superadmin). Lista de tenants,
// estado/plan, suspender/reactivar, "impersonar" → dhk8-platform-tenants (REST + mock).
// The route itself is role-gated in App.tsx; this page assumes the superadmin role.
import { useNavigate } from 'react-router-dom'
import { Building2, Ban, RotateCcw, UserCheck } from 'lucide-react'
import { listTenants, suspendTenant, reactivateTenant } from '../../lib/clients/tenants.js'
import { useAuthStore } from '../../stores/auth-store.js'
import { useAsync, asyncState } from '../../lib/use-async.js'

const STATUS_BADGE: Record<string, string> = { ACTIVE: 'adm-badge--ok', SUSPENDED: 'adm-badge--danger', TRIAL: 'adm-badge--warn' }
const STATUS_LABEL: Record<string, string> = { ACTIVE: 'Activa', SUSPENDED: 'Suspendida', TRIAL: 'Prueba' }

export default function SuperadminPage() {
  const list = useAsync((s) => listTenants(s))
  const impersonate = useAuthStore((s) => s.impersonate)
  const nav = useNavigate()
  async function suspend(id: string) { if (confirm('¿Suspender este tenant? No podrán operar hasta reactivarlo.')) { await suspendTenant(id); list.reload() } }
  async function reactivate(id: string) { await reactivateTenant(id); list.reload() }
  function doImpersonate(id: string, name: string) { impersonate(id, name); nav('/dashboard') }
  return (
    <div className="adm-page">
      <div className="adm-page__head"><div><h1 className="adm-page__title">Cuentas de terceros</h1><p className="adm-page__sub">Superadmin · tenants de la plataforma, planes e impersonación</p></div></div>
      {asyncState(list.loading, list.error, list.reload)}
      {list.data && <div className="adm-card adm-card--pad0"><div className="adm-list">
        {list.data.length === 0 && <div className="adm-empty">Sin cuentas</div>}
        {list.data.map((tnt) => (
          <div key={tnt.id} className="adm-row">
            <span style={{ color: 'var(--pos-fg-tertiary)' }}><Building2 size={18} /></span>
            <div className="adm-row__main"><div className="adm-row__title">{tnt.name}</div><div className="adm-row__meta">{tnt.legalName} · {tnt.plan} · {tnt.ownerEmail} · alta {tnt.createdAt}</div></div>
            <div className="adm-row__tail">
              <span className={`adm-badge ${tnt.mode === 'LIVE' ? 'adm-badge--ok' : 'adm-badge--warn'}`}>{tnt.mode === 'LIVE' ? 'EN VIVO' : 'PRUEBAS'}</span>
              <span className={`adm-badge ${STATUS_BADGE[tnt.status]}`}>{STATUS_LABEL[tnt.status]}</span>
              {tnt.status === 'SUSPENDED'
                ? <button className="adm-btn adm-btn--ghost adm-btn--sm" onClick={() => reactivate(tnt.id)} title="Reactivar"><RotateCcw size={15} /></button>
                : <button className="adm-btn adm-btn--ghost adm-btn--sm adm-btn--danger" onClick={() => suspend(tnt.id)} title="Suspender"><Ban size={15} /></button>}
              <button className="adm-btn adm-btn--ghost adm-btn--sm" onClick={() => doImpersonate(tnt.id, tnt.name)} title="Impersonar"><UserCheck size={15} /></button>
            </div>
          </div>
        ))}
      </div></div>}
    </div>
  )
}
